import { Injectable } from "@angular/core";
import { InputViewModel } from "../shared";

@Injectable()
export class MultiChoiceItemViewModel extends InputViewModel {

  triState: boolean = false;

}